import { apiClient } from '../../../../helpers/api_helper';

export const AddCustomerData  = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/Customer/InsertCustomer`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}; 

export const AddAllCustomerData  = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Customer/GetAllCustomerGrid?page=1&limit=50`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}; 


export const GetOldGoldRateByKaratIdApi = async (karatId: any) => {
    try {
        const response = await apiClient.get(`/api/v1/GoldRateMaster/GetTodaysGoldRateMaster?ktId=${karatId}`);
        return response.data; 
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};

export const GetKaratSelectList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Karat/GetKaratSelectList`);
        return response.data; 
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};

export const GetStyleList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/StylesMaster/GetStylesSelectList`);
        return response.data; 
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};
export const GetCollectionList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Collection/GetCollectionSelectList`);
        return response.data; 
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};
export const GetCategroyList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Category/GetCategorySelectList`);
        return response.data; 
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
};
